/* About Us page: inline video, animated FAQ accordion and GA4 dataLayer pushes. */
(function () {
  if (window.ehAboutReady) return;
  window.ehAboutReady = true;

  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  document.addEventListener("click", function (e) {
    var cta = e.target.closest("[data-about-cta]");
    if (cta)
      track("about_cta_click", { cta: cta.getAttribute("data-about-cta") });

    var play = e.target.closest("[data-about-play]");
    if (!play) return;
    var card = play.closest(".ab-video");
    var player = card && card.querySelector(".ab-video__player");
    if (!player) return;
    var tpl = player.querySelector("template");
    if (tpl) {
      player.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
    }
    card.classList.add("is-playing");
    var video = player.querySelector("video");
    if (video) video.play();
    track("about_video_play", {
      video: card.getAttribute("data-video-name") || "",
    });
  });

  /* details/summary opens instantly by default; animate the item's height instead. */
  var reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  var DURATION = 320;

  function animateHeight(item, from, to, done) {
    item.style.height = from + "px";
    var anim = item.animate([{ height: from + "px" }, { height: to + "px" }], {
      duration: DURATION,
      easing: "cubic-bezier(0.4, 0, 0.2, 1)",
    });
    anim.onfinish = anim.oncancel = function () {
      item.style.height = "";
      done();
    };
  }

  document.querySelectorAll(".ab-faq__item").forEach(function (item) {
    var summary = item.querySelector("summary");
    var busy = false;

    summary.addEventListener("click", function (e) {
      if (reduceMotion || !item.animate) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      var start = item.offsetHeight;

      if (item.open) {
        var cs = getComputedStyle(item);
        var closed =
          summary.offsetHeight +
          parseFloat(cs.paddingTop) +
          parseFloat(cs.paddingBottom);
        animateHeight(item, start, closed, function () {
          item.open = false;
          busy = false;
        });
        return;
      }

      item.open = true;
      var end = item.offsetHeight;
      animateHeight(item, start, end, function () {
        busy = false;
      });
    });

    item.addEventListener("toggle", function () {
      if (!item.open) return;
      var q = item.querySelector(".ab-faq__q .ab__title");
      track("about_faq_open", { question: q ? q.textContent.trim() : "" });
    });
  });
})();
